<template>
	<div class="nutrition">
		<Breadcrumbs :items="items" />
		<v-container fluid>
			<v-row no-gutters>
				<v-col cols="12" md="12">
					<p
						v-if="treatments.length == 0"
						class="font-weight-thin ml-2"
						v-translate
					>No treatments created.</p>
					<v-list v-else flat>
						<v-list-item
							:key="treatment.name"
							style="border: 1px solid #e0e0e0; border-radius: 5px"
							v-for="treatment in treatments"
						>
							<v-list-item-icon class="mr-3">
								<v-icon>mdi-clipboard-text-outline</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									<strong>{{treatment.name}}</strong>
								</v-list-item-title>
								<v-list-item-subtitle></v-list-item-subtitle>
							</v-list-item-content>
							<v-list-item-action>
								<v-row no-gutters>
									<v-chip text-color="grey">
										<span v-if="custom">{{customTreatment.name}}</span>
										<span v-else-if="category === 'nut'" v-translate>Nutrition</span>
										<span v-else-if="category === 'qg'">Qi Gong</span>
										<span v-else-if="category === 'tn'">Tui Na</span>
									</v-chip>
									<v-btn icon @click="editTreatment(treatment)">
										<v-icon color="primary">edit</v-icon>
									</v-btn>
									<v-btn icon @click="deleteTreatment(treatment)">
										<v-icon color="primary">delete</v-icon>
									</v-btn>
								</v-row>
							</v-list-item-action>
						</v-list-item>
					</v-list>
					<v-btn
						small
						fab
						class="mb-3"
						color="primary"
						@click="showNewTreatmentForm = !showNewTreatmentForm"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row no-gutters v-if="showNewTreatmentForm">
				<v-col cols="12" md="12">
					<PreMadeTreatmentForm ref="form" @new-treatment="createTreatment" :category="category" />
				</v-col>
				<v-col cols="6" md="6">
					<v-alert v-model="error" color="red" icon="warning">
						<translate>Error</translate>
					</v-alert>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PreMadeTreatmentForm from "@/components/settings/PreMadeTreatmentForm.vue";
import axios from "axios";

export default {
	name: "PreMadeTreatment",
	props: ["category", "custom"],
	components: {
		Breadcrumbs,
		PreMadeTreatmentForm
	},
	data: () => ({
		treatmentName: null,
		showNewTreatmentForm: false,
		loading: false,
		editInfo: false,
		error: false,
		treatments: [],
		customTreatment: {}
	}),
	computed: {
		categoryName() {
			return ({
				nut: this.$gettext("Nutrition"),
				qg: "Qi Gong",
				tn: "Tui Na"
			})
		},
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: { name: "home" }
				},
				{
					text: this.$gettext("Treatments"),
					disabled: false,
					link: true,
					to: { name: "treatments" }
				},
				{
					text: this.custom ? this.customTreatment.name : this.categoryName[this.category],
					disabled: true,
					link: true
				}
			]
		}
	},
	methods: {
		editTreatment(treatment) {
			this.$router.push({
				name: this.custom ? "edit-custom-pre-made-treatment" : "edit-pre-made-treatment",
				params: {
					custom: this.custom,
					customTreatment: this.customTreatment,
					tid: treatment.id,
					treatment: treatment,
					category: this.category
				}
			});
		},
		deleteTreatment(treatment) {
			axios
				.post("/api/premade_treatments/" + treatment.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
						this.treatments.splice(this.treatments.indexOf(treatment), 1);
					}
				})
				.catch(error => console.log(error));
		},
		createTreatment(treatment) {
			console.log(treatment);
			this.error = false;
			const formData = new FormData();
			formData.append("name", treatment.name);
			formData.append("text", treatment.text);
			if(this.custom) formData.append("custom_treatment_id", this.customTreatment.id);
			else formData.append("category", this.category);
			axios
				.post("/api/premade_treatments", formData)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "created") {
						this.treatments.push(response.data.treatment);
						this.$refs.form.resetFields();
						this.showNewTreatmentForm = false;
					} else {
						this.error = true;
					}
				})
				.catch(error => {
					console.log(error);
					this.error = true;
				});
		}
	},
	created() {
		let params;
		if(this.custom || this.$route.params.ctid) {
			params = {
				custom: true,
				id: this.$route.params.ctid
			}
		} else {
			params = {
				custom: false,
				category: this.category
			}
		}
		axios
			.get("/api/premade_treatments", {
				params: params
			})
			.then(response => {
				console.log(response.data);
				this.treatments = response.data.treatments;
				if(this.custom || this.$route.params.ctid) this.customTreatment = response.data.treatment;
			})
			.catch(error => console.log(error));
	}
};
</script>